import differenceInYears from "date-fns/differenceInYears";
import _uniqBy from "lodash/uniqBy";

export const getAge = (dob: any) => {
  if (dob && dob.length) {
    const age = differenceInYears(new Date(), new Date(dob));
    return age ? age : 1;
  }
  return null;
};

export const getMinDate = (minDate: string) => {
  if (minDate?.length) {
    let modifiedMinDate: any = minDate?.split("/");
    if (modifiedMinDate?.length) {
      return `${modifiedMinDate[2]}-${modifiedMinDate[1]}-${modifiedMinDate[0]}`;
    } else {
      return "01-01-2000";
    }
  } else {
    return "01-01-2000";
  }
};

export const getMaxDate = () => {
  var today: any = new Date();
  var dd: any = today.getDate();
  var mm: any = today.getMonth() + 1;
  var yyyy = today.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  return (today = yyyy + "-" + mm + "-" + dd);
};

export const defaultAnimationProps = (fileName?: any) => {
  return {
    loop: true,
    autoplay: true,
    animationData: fileName,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
};

export const checkAllOptionsHaveImgs = (items: any) => {
  let noImgFound = false;
  let isValidImageOptions = [];
  items.map((opt: any) => {
    if (opt?.url) {
      isValidImageOptions.push(opt);
    }
  });
  if (isValidImageOptions?.length === items?.length) {
    noImgFound = true;
  }
  return noImgFound;
};

export const metaTagSymptomChecker: any = () => {
  return {
    title: "Check your symptoms online at apollo 247",
    description:
      "Apollo247 symptom checker - Know your medical condition based on the symptoms you reported online,",
    canonicalLink: "https://www.apollo247.com/symptom-checker",
  };
};

export const getAvailableData = (
  resp: any,
  autoSuggestSelectedItem?: any,
  selectedSymptomsItems?: any
) => {
  let modifiedsymptomOptions =
    resp?.options?.length > 0
      ? resp.options
      : resp?.questioninfo?.questions?.[0]?.options?.length > 0
      ? resp.questioninfo.questions[0].options
      : [];

  let questionType = resp?.cardinality
    ? resp.cardinality
    : resp?.questioninfo?.questions?.[0]?.cardinality?.length > 0
    ? resp?.questioninfo?.questions?.[0]?.cardinality
    : "";

  let dialogueType = resp?.type
    ? resp?.type
    : resp?.questioninfo?.questions?.[0]?.type?.length > 0
    ? resp.questioninfo.questions[0].type
    : "";

  let modifiedOptionList =
    resp?.options?.input_detail?.unit_detail?.length > 0
      ? resp?.options?.input_detail?.unit_detail
      : resp?.input_detail?.unit_detail?.length > 0
      ? resp?.input_detail?.unit_detail
      : resp?.questioninfo?.questions?.[0]?.input_detail?.unit_detail?.length >
        0
      ? resp?.questioninfo?.questions?.[0]?.input_detail?.unit_detail
      : resp?.questioninfo?.questions?.[0]?.input_detail?.unit_detail?.length >
        0
      ? resp?.questioninfo?.questions?.[0]?.input_details?.unit_detail
      : [];

  let heading = resp?.text
    ? resp?.text
    : resp?.questioninfo?.header?.length > 0
    ? resp?.questioninfo?.header
    : resp?.questioninfo?.questions?.[0]?.text?.length > 0
    ? resp?.questioninfo?.questions?.[0]?.text
    : "";

  let questionId = resp?.qid
    ? resp?.qid
    : resp?.questioninfo?.questions?.[0]?.qid?.length > 0
    ? resp?.questioninfo?.questions?.[0]?.qid
    : "";
  let isMandatory = resp?.mandatory
    ? true
    : resp?.questioninfo?.mandatory
    ? true
    : false;

  let questionInfo = resp?.description
    ? resp?.description
    : resp?.questioninfo?.questions?.[0]?.description?.length > 0
    ? resp?.questioninfo?.questions?.[0]?.description
    : "";

  let multipleQuestionsInfo: any = [];
  if (modifiedsymptomOptions?.length > 0) {
    modifiedsymptomOptions.map((opt: any) => {
      if (opt?.description?.length > 0) {
        multipleQuestionsInfo.push(opt);
      }
    });
  }
  if (
    resp?.questioninfo?.questions?.[0]?.autosuggest?.mode &&
    autoSuggestSelectedItem?.length > 0
  ) {
    autoSuggestSelectedItem.map((opt: any) => {
      if (
        opt?.description?.length > 0 &&
        resp?.dialogueId === opt?.dialogueId
      ) {
        multipleQuestionsInfo.push(opt);
      }
    });
  }

  if (selectedSymptomsItems?.length > 0) {
    selectedSymptomsItems.map((opt: any) => {
      if (
        opt?.description?.length > 0 &&
        resp?.dialogueId === opt?.dialogueId
      ) {
        multipleQuestionsInfo.push(opt);
      }
    });
  }
  multipleQuestionsInfo =
    multipleQuestionsInfo?.length > 0
      ? _uniqBy(multipleQuestionsInfo, "id")
      : [];

  let inputTypeBoxType = resp?.input_detail?.inputboxtype
    ? resp?.input_detail?.inputboxtype
    : resp?.questioninfo?.questions?.[0]?.input_detail?.inputboxtype
    ? resp?.questioninfo?.questions?.[0]?.input_detail?.inputboxtype
    : "" || "";

  let inputType = resp?.input_detail?.input
    ? resp?.input_detail?.input
    : resp?.questioninfo?.questions?.[0]?.input_detail?.input
    ? resp?.questioninfo?.questions?.[0]?.input_detail?.input
    : "" || "";

  let inputPlaceHolder = resp?.input_detail?.placeholder
    ? resp.input_detail.placeholder
    : resp?.questioninfo?.questions?.[0]?.input_detail?.placeholder
    ? resp?.questioninfo?.questions?.[0]?.input_detail?.placeholder
    : "" || "";

  return {
    modifiedsymptomOptions,
    questionType,
    dialogueType,
    modifiedOptionList,
    heading,
    questionId,
    isMandatory,
    questionInfo,
    multipleQuestionsInfo,
    inputTypeBoxType,
    inputType,
    inputPlaceHolder,
  };
};
